<!--  -->
<template>
  <div class="content">
    <header :class="chid_hover ? 'sticky' : ''">
      <div class="top">
        <!-- 导航 -->
        <div class="card">
          <img
            src="../../assets/logo1.png"
            alt="湖南生易圈教育咨询有限公司"
            v-if="!roll || !chid_hover"
          />
          <img
            src="../../assets/logo.png"
            alt="湖南生易圈教育咨询有限公司"
            v-if="roll || chid_hover"
          />

          <!-- pc导航 -->

          <nav>
            <ul class="nav_list">
              <li class="nav_item">
                <a
                  class="a"
                  href="#"
                  @click="topUrl(0, '/')"
                  :class="
                    type == 0 && roll
                      ? 'active'
                      : type == 0 && !roll
                      ? 'actives'
                      : ''
                  "
                  :style="roll ? 'color:#333' : ''"
                  >首页</a
                >
              </li>
              <li class="nav_item" id="serve">
                <a
                  href="#"
                  class="a"
                  :class="
                    type == 1 && roll
                      ? 'active'
                      : type == 1 && !roll
                      ? 'actives'
                      : ''
                  "
                  :style="roll ? 'color:#333' : ''"
                  >产品服务 <span class="iconfont icon-angle-down ioc"></span
                ></a>
                <span class="san san_serve"></span>
                <ul class="chid_serve">
                  <li
                    class="chid_item"
                    v-for="(item, index) in chid_list"
                    :key="index"
                    @click="topUrl(1, item.url)"
                  >
                    <a href="#" class="a">
                      <div class="right">
                        <div class="title">{{ item.title }}</div>
                      </div>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav_item">
                <a
                  href="#"
                  class="a"
                  @click="topUrl(2, '/New')"
                  :class="
                    type == 2 && roll
                      ? 'active'
                      : type == 2 && !roll
                      ? 'actives'
                      : ''
                  "
                  :style="roll ? 'color:#333' : ''"
                  >新闻资讯</a
                >
              </li>
              <li class="nav_item">
                <a
                  href="#"
                  class="a"
                  @click="topUrl(3, '/Contact_us')"
                  :class="
                    type == 3 && roll
                      ? 'active'
                      : type == 3 && !roll
                      ? 'actives'
                      : ''
                  "
                  :style="roll ? 'color:#333' : ''"
                  >联系我们</a
                >
              </li>
              <!-- <li class="nav_item">
                <a
                  href="#"
                  class="a"
                  @click="topUrl(4, '/About')"
                  :class="type == 4 ? 'active' : ''"
                  :style="roll ? 'color:#333' : ''"
                  >关于我们</a
                >
              </li> -->
              <li class="nav_item" id="school">
                <a href="#" class="a" :style="roll ? 'color:#333' : ''"
                  >货运教学 <span class="iconfont icon-angle-down ioc"></span
                ></a>
                <span class="san san_school"></span>
                <div class="school_list">
                  <div class="hearder">货运教学平台合作院校入口</div>
                  <div class="school">
                    <ul>
                      <li
                        class="school_item"
                        v-for="(item, index) in school_list"
                        :key="index"
                      >
                        <a target="_blank" :href="item.href">
                          {{ item.text }}
                        </a>
                      </li>
                    </ul>
                    <div class="row"></div>
                    <ul>
                      <li
                        class="school_item"
                        v-for="(item, index) in school_lists"
                        :key="index"
                      >
                        <a target="_blank" :href="item.href">
                          {{ item.text }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
    <div>
      <router-view />
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Footer,
  },
  data() {
    //这里存放数据
    return {
      chid_list: [
        {
          title: "货运教学平台",
          url: "/Service_education",
        },
        {
          title: "货代选手训练营 ",
          url: "/forwarder",
        },
        {
          title: "外贸技能培训",
          url: "/trade",
        },
        {
          title: "人才定制输出",
          url: "/personnel",
        },
      ],
      //学校
      school_list: [
        {
          href: "https://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=csxy",
          text: "长沙学院 ",
        },
        {
          href: "https://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hkgy",
          text: "张家界航空工业职业学院  ",
        },
        {
          href: "https://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=gsdx",
          text: "湖南工商大学  ",
        },
        {
          href: "https://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=gztl",
          text: "广州铁路职业技术学院 ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=znlkd",
          text: "中南林业科技大学 ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hnxda",
          text: "湖南现代物流职业技术学院  ",
        },
      ],
      school_lists: [
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hngyxy",
          text: "湖南工业职业技术学院 ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hngczy",
          text: "湖南工程职业技术学院  ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hbjjxy",
          text: "湖北经济学院  ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hnwmzy",
          text: "湖南外贸职业学院  ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=hyjsxy",
          text: "衡阳技师学院 ",
        },
        {
          href: "http://www.sinoetrade.com/htrans_school/login.php?pageid=3&school=htdx",
          text: "浩通教育咨询  ",
        },
      ],
      current: 0,
      drawer: false,
      chid_show: false,
      roll: false, //滑动
      roll_true: false,
      chid_hover: false,
      type: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.type = index;
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
    handleClose() {
      this.$store.state.current = 1;
      this.chid_show = !this.chid_show;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.type = localStorage.getItem("current");
    const headerEl = document.querySelector("header");
    // const scrollToTop = document.querySelector(".scroll-to-top");

    window.addEventListener("scroll", () => {
      // 获取
      let height = headerEl.getBoundingClientRect().height;

      if (window.pageYOffset - height > 10) {
        if (!headerEl.classList.contains("sticky")) {
          headerEl.classList.add("sticky");
          this.roll = true;
          this.chid_hover = true;
          this.roll_true = true;
        }
      } else {
        headerEl.classList.remove("sticky");

        this.roll = false;
        this.chid_hover = false;
        this.roll_true = false;
      }
    });
    //子菜单显示
    $(".chid_serve").hide();
    $(".san_serve").hide();
    $("#serve").hover(
      () => {
        $(".chid_serve").show();
        $(".san_serve").show();
        this.chid_hover = true;
        this.roll = true;
      },
      () => {
        $(".chid_serve").hide();
        $(".san_serve").hide();
        if (!this.roll_true) {
          this.chid_hover = false;
          this.roll = false;
        }
      }
    );
    // 学校
    $(".school_list").hide();
    $(".san_school").hide();
    $("#school").hover(
      () => {
        $(".school_list").show();
        $(".san_school").show();
        this.chid_hover = true;
        this.roll = true;
      },
      () => {
        $(".school_list").hide();
        $(".san_school").hide();
        if (!this.roll_true) {
          this.chid_hover = false;
          this.roll = false;
        }
      }
    );
  },
  beforeCreate() {
    if (this.$route.path == "/") {
      localStorage.setItem("current", 0);
    }
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {
    this.type = localStorage.getItem("current");
  }, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../Home/pc);
@import url(../Home/mod);
</style>
